import { render, staticRenderFns } from "./pending.vue?vue&type=template&id=2c2f77b3&scoped=true&"
import script from "./pending.vue?vue&type=script&lang=js&"
export * from "./pending.vue?vue&type=script&lang=js&"
import style0 from "./pending.vue?vue&type=style&index=0&id=2c2f77b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2f77b3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c2f77b3')) {
      api.createRecord('2c2f77b3', component.options)
    } else {
      api.reload('2c2f77b3', component.options)
    }
    module.hot.accept("./pending.vue?vue&type=template&id=2c2f77b3&scoped=true&", function () {
      api.rerender('2c2f77b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/install/pending.vue"
export default component.exports